import { createStyle } from '@gluestack-style/react';

export const SafeAreaView = createStyle({});
